import { render } from "./Main.vue?vue&type=template&id=33237b1d"
const script = {}
script.render = render

export default script